import { render, staticRenderFns } from "./addPatient.html?vue&type=template&id=d9d5831e&scoped=true&external"
import script from "./addPatient.js?vue&type=script&lang=js&external"
export * from "./addPatient.js?vue&type=script&lang=js&external"
import style0 from "./addPatient.scss?vue&type=style&index=0&id=d9d5831e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d5831e",
  null
  
)

export default component.exports